// MARK: - Audio Asset URL Manifest
// Maps catalog names / enum values to public serving paths.

import { CATALOG } from './sfxLibrary';
import type { MusicTrack } from './types';

/**
 * Return the public URL for a sound effect by name.
 * Looks up the effect in CATALOG to determine its category, then constructs
 * the path: /audio/sfx/<category>/<effectName>.mp3
 *
 * Throws if the effect name is not found in any catalog category.
 */
export function sfxUrl(effectName: string): string {
  for (const [category, effects] of Object.entries(CATALOG)) {
    if (effects.includes(effectName)) {
      return `/audio/sfx/${category}/${effectName}.mp3`;
    }
  }
  throw new Error(`sfxUrl: effect "${effectName}" not found in CATALOG`);
}

/**
 * Return the public URL for a music track.
 * Path: /music/<rawValue>.mp3
 */
export function musicUrl(track: MusicTrack): string {
  return `/music/${track}.mp3`;
}

/**
 * Return the public URL for a completion stinger.
 * "roast" → /audio/sfx/Roasted.mp3
 * "toast" → /audio/sfx/Toasted.mp3
 */
export function stingerUrl(mode: 'roast' | 'toast'): string {
  return mode === 'roast'
    ? '/audio/sfx/Roasted.mp3'
    : '/audio/sfx/Toasted.mp3';
}
